import React, { useEffect, useRef, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const START_SECONDS = 17 * 60 + 34; // 00:17:34

function format(total: number) {
  const h = Math.floor(total / 3600);
  const m = Math.floor(total % 3600 / 60);
  const s = total % 60;
  return {
    h: String(h).padStart(2, '0'),
    m: String(m).padStart(2, '0'),
    s: String(s).padStart(2, '0')
  };
}
export function CountdownTimer() {
  const [remaining, setRemaining] = useState(START_SECONDS);
  const ref = useRef<number>(START_SECONDS);
  useEffect(() => {
    const id = setInterval(() => {
      ref.current -= 1;
      if (ref.current < 0) {
        // reinicio automático al llegar a cero
        ref.current = START_SECONDS;
      }
      setRemaining(ref.current);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const {
    h,
    m,
    s
  } = format(remaining);
  const boxes = [{
    v: h,
    label: 'Horas'
  }, {
    v: m,
    label: 'Min'
  }, {
    v: s,
    label: 'Seg'
  }];
  return <div className="mx-auto max-w-md" data-id="element-70" data-mp="1c0yfs5qvxuwy">
      <div className="flex items-center justify-center gap-2 text-sm font-bold text-mauve" data-id="element-71" data-mp="1bzvr84h1c4k7">
        <ClockIcon className="h-4 w-4" data-id="element-72" data-mp="1h0t9eh21oylp" />
        <span data-id="element-73" data-mp="1gxf2qwmcm38g">Esta oferta expira en:</span>
      </div>
      <div className="mt-3 flex items-center justify-center gap-2 sm:gap-3" data-id="element-74" data-mp="123ka916i2qjf">
        {boxes.map((b, i) => <React.Fragment key={b.label} data-id="element-75" data-mp="172df657q197z" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-76" data-mp="1ur6du9fq9v6a">
              <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-plum-deep font-display text-3xl font-black tabular-nums text-white shadow-lg sm:h-20 sm:w-20 sm:text-4xl" data-id="element-77" data-mp="1ushjyfwnbf0k">
                {b.v}
              </div>
              <span className="mt-1.5 text-[11px] font-bold uppercase tracking-wide text-plum/60" data-id="element-78" data-mp="1kzipwiidqw9k">
                {b.label}
              </span>
            </div>
            {i < boxes.length - 1 && <span className="-mt-4 font-display text-2xl font-black text-mauve sm:text-3xl" data-id="element-79" data-mp="2igqx6tfsmug3">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}